import React, { useState } from "react";
import { Modal, Typography } from "antd";
import PrimaryButton from "../Forms/PrimaryButton";

const { Title } = Typography;
export default function UpdateStatusModal({
  open,
  onClose,
  handleSubmit,
  title = "Update Status",
  options = [],
  loading,
}) {
  const [status, setStatus] = useState("");

  const handleProceed = () => {
    if (status) {
      handleSubmit(status);
    }
  };

  return (
    <Modal
      className="form-css-2 custom-modal status-modal"
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      width={300}
    >
      {/* Header */}
      <div className="flex justify-between items-center">
        <Title level={2} className="text-lg font-semibold text-black !mb-0 font-abhaya">
          {title}
        </Title>
      </div>

      {/* Status Options */}
      <div className="w-full">
        {options.map((item) => {
          const isSelected = status === item.value;
          return (
            <div
              key={item.value}
              onClick={() => setStatus(item.value)}
              className={`flex items-center cursor-pointer px-3 py-2 rounded-lg my-2 text-base transition-colors
                ${
                  isSelected
                    ? "bg-red-50 text-[#A33434] font-bold"
                    : "bg-transparent text-black font-medium"
                }
              `}
            >
              {item.icon}
              <span className="pl-3">{item.label}</span>
            </div>
          );
        })}
      </div>

      {/* Footer */}
      <div className="w-full mt-4 flex justify-center">
        <PrimaryButton
          text="Proceed"
          onClick={handleProceed}
          disabled={!status}
          loading={loading}
          className="me-[30px]"
        />
      </div>
    </Modal>
  );
}
